import type { CSSProperties } from 'react';
import {
  TABBIO_SPARK_PATH,
  TABBIO_SPARK_VIEWBOX,
} from '../assistant-ui/tabbio-spark-path';

/** Web twin of SparkMark.tsx. Fills with `color`, else `currentColor`. */
export function SparkMark({
  size = 16,
  color,
  style,
}: {
  size?: number;
  color?: string;
  style?: CSSProperties;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox={TABBIO_SPARK_VIEWBOX}
      aria-hidden
      focusable="false"
      style={{ display: 'block', flexShrink: 0, ...style }}
    >
      <path d={TABBIO_SPARK_PATH} fill={color ?? 'currentColor'} />
    </svg>
  );
}
